module.exports = __webpack_public_path__ + "img/no-eat.a7a09867.png";